import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { usePageTitle } from '../hooks/usePageTitle';
import DocumentUploadStep from '../components/CustomerFlow/Steps/DocumentUploadStep';
import { Card, CardBody, LayoutContainer } from '../components/ui';
import '../styles/infrastructureScreens.css';
import { safeLocalStorage } from '../utils/safeLocalStorage';

const MobileOnboardingPage = () => {
  const { token } = useParams();
  
  // Establecer el título de la página
  usePageTitle('Documentos de Venta');

  // Obtener datos del token desde localStorage (ya validados por MobileProtectedRoute)
  const tokenScope = useMemo(() => {
    const storedScope = safeLocalStorage.getItem('temp_tokenScope');
    return storedScope ? JSON.parse(storedScope) : {};
  }, []);

  // Manejo de completación de documentos
  const handleDocumentsComplete = (data) => {
    Swal.fire({
      title: '¡Documentos Completados!',
      html: `
        <p>Has completado la carga de documentos exitosamente.</p>
        <small class="text-muted">Puedes cerrar esta ventana o continuar cargando documentos opcionales si los hay.</small>
      `,
      icon: 'success',
      showCancelButton: true,
      confirmButtonText: 'Cerrar',
      cancelButtonText: 'Continuar',
    }).then((result) => {
      if (result.isConfirmed) {
        window.close(); // Intenta cerrar la pestaña
      }
      // Si cancela, simplemente continúa en la página
    });
  };

  return (
    <div className="rg-infra-screen rg-mobile-onboarding">
      <LayoutContainer size="lg" className="rg-mobile-onboarding__container">
        <Card className="rg-mobile-onboarding__card rg-elevation-1">
          <CardBody className="rg-mobile-onboarding__card-body">
            <DocumentUploadStep
              standalone={true}
              tokenScope={tokenScope}
              onComplete={handleDocumentsComplete}
            />
          </CardBody>
        </Card>
      </LayoutContainer>
    </div>
  );
};

export default MobileOnboardingPage; 